module.exports = __webpack_public_path__ + "img/pGoal.4db7ffad.svg";